class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalContent = this.querySelector('.search-modal');
    this.modalPlaceholder = null;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isHeaderSearch() {
    return this.classList.contains('header__search');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const clickInsideDetachedModal = this.modalContent && this.modalContent.contains(event.target);
    if ((!this.contains(event.target) && !clickInsideDetachedModal) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  moveSearchModalToBody() {
    if (!this.isHeaderSearch() || !this.modalContent || this.modalContent.parentElement === document.body) return;

    this.modalPlaceholder = document.createComment('header-search-modal-placeholder');
    this.modalContent.after(this.modalPlaceholder);
    document.body.appendChild(this.modalContent);
    this.modalContent.classList.add('search-modal--detached');
  }

  restoreSearchModal() {
    if (!this.modalContent || !this.modalPlaceholder || !this.modalPlaceholder.parentNode) return;

    this.modalPlaceholder.parentNode.insertBefore(this.modalContent, this.modalPlaceholder);
    this.modalPlaceholder.remove();
    this.modalPlaceholder = null;
    this.modalContent.classList.remove('search-modal--detached');
    this.modalContent.style.removeProperty('--sf-search-detached-top');
    this.modalContent.style.removeProperty('--sf-search-detached-width');
  }

  updateDetachedSearchLayout() {
    if (!this.isHeaderSearch() || !this.modalContent || !this.modalContent.classList.contains('search-modal--detached')) return;

    const header = this.closest('.section-header')?.querySelector('.header');
    if (!header) return;

    const headerRect = header.getBoundingClientRect();
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const top = Math.max(8, Math.round(headerRect.top + (isDesktop ? 14 : 8)));
    const headerWidth = Math.max(0, Math.round(headerRect.width));
    const targetWidth = isDesktop
      ? Math.min(560, Math.max(420, headerWidth - 120))
      : Math.max(0, headerWidth - 16);
    const clampedWidth = Math.max(isDesktop ? 420 : 0, Math.min(window.innerWidth - 16, targetWidth));

    this.modalContent.style.setProperty('--sf-search-detached-top', top + 'px');
    this.modalContent.style.setProperty('--sf-search-detached-width', clampedWidth + 'px');
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);

    if (this.isHeaderSearch()) {
      this.moveSearchModalToBody();
      this.onWindowResize = this.onWindowResize || this.updateDetachedSearchLayout.bind(this);
      this.updateDetachedSearchLayout();
      window.requestAnimationFrame(() => this.updateDetachedSearchLayout());
      window.addEventListener('resize', this.onWindowResize);
    }

    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    if (this.isHeaderSearch()) {
      document.body.classList.add('search-modal-open');
    }

    const focusContainer = this.modalContent?.classList.contains('search-modal--detached')
      ? this.modalContent.querySelector('[tabindex="-1"]') || this.modalContent
      : this.detailsContainer.querySelector('[tabindex="-1"]');
    const focusTarget = this.modalContent?.querySelector('input:not([type="hidden"])')
      || this.detailsContainer.querySelector('input:not([type="hidden"])');

    trapFocus(focusContainer, focusTarget || focusContainer);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (this.isHeaderSearch()) {
      document.body.classList.remove('search-modal-open');
      if (this.onWindowResize) {
        window.removeEventListener('resize', this.onWindowResize);
      }
      this.restoreSearchModal();
    }
  }
}

customElements.define('details-modal', DetailsModal);